import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularConnectedNoInternet4Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMThIMjJWMTBIMjBWMThaTTIwIDIySDIyVjIwSDIwVjIyWk0yIDIySDE4VjhIMjJWMkwyIDIyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularConnectedNoInternet4Bar = createIcon('SignalCellularConnectedNoInternet4Bar', [
  ['path', { d: 'M20 18H22V10H20V18ZM20 22H22V20H20V22ZM2 22H18V8H22V2L2 22Z', key: 'z96uf3' }],
]);

export default SignalCellularConnectedNoInternet4Bar;
